import { render, staticRenderFns } from "./caps-details-form.component.vue?vue&type=template&id=68c84b4c"
import script from "./caps-details-form.component.ts?vue&type=script&lang=ts&external"
export * from "./caps-details-form.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c84b4c')) {
      api.createRecord('68c84b4c', component.options)
    } else {
      api.reload('68c84b4c', component.options)
    }
    module.hot.accept("./caps-details-form.component.vue?vue&type=template&id=68c84b4c", function () {
      api.rerender('68c84b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/detail-forms/caps-details-form/caps-details-form.component.vue"
export default component.exports